import { render, staticRenderFns } from "./SetupWelcome.vue?vue&type=template&id=dabe4004&"
import script from "./SetupWelcome.vue?vue&type=script&lang=js&"
export * from "./SetupWelcome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports